//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import OnisVidaAPI from '@/api/promotores/onisvida.api'
export default {
	components: { ColumnsSelect },
	data() {
		return {
			columns: [
				{ name: 'nombre', field: 'nombre', label: 'Nombre', sortable: true, align: 'left' },
				{ name: 'apellido_paterno', field: 'apellido_paterno', label: 'Apellido Paterno', sortable: true, align: 'left' },
				{ name: 'apellido_materno', field: 'apellido_materno', label: 'Apellido Materno', sortable: true, align: 'left' },
				{ name: 'correo_electronico', field: 'correo_electronico', label: 'Email', sortable: true },
				{ name: 'telefono_celular', field: 'telefono_celular', label: 'Celular', sortable: true },
				{ name: 'promotor', field: 'usuario', label: 'Promotor', sortable: true, align: 'left' },
				{ name: 'entidad_federativa', field: 'entidad_federativa', label: 'Entidad', sortable: true },
				{ name: 'numero_seguridad_social', field: 'numero_seguridad_social', label: 'NSS', sortable: true },
				{ name: 'fecha_nacimiento', field: 'fecha_nacimiento', label: 'Fecha de nacimiento', sortable: true },
				{ name: 'etapa', field: 'etapa', label: 'Etapa', sortable: true, format: this.formatEtapa },
				{ name: 'creado', field: 'creado', label: 'Creado', sortable: true},
			],
			visible_columns: [
				'nombre', 
				'apellido_paterno', 
				'apellido_materno',
				'correo_electronico',
				'telefono_celular',
				'promotor',
				'creado',
			],
			prospectos: [],
			loading: false,
		}
	},

	mounted() {
		this.loadProspectos()
	},

	methods: {
		async loadProspectos() {
			try {
				this.loading = true
				this.prospectos = await OnisVidaAPI.prospectos()
			} finally {
				this.loading = false
			}
		},
		formatEtapa(etapa) {
			return ({
        "0": 'Recibido',
        "1": 'Rechazado',
        "2": 'Recabando información',
        "3": 'Crédito aprobado'
      })[etapa] || null
		}
	}
}
